import { render, staticRenderFns } from "./TableFilters.vue?vue&type=template&id=50b4ca2c&"
import script from "./TableFilters.vue?vue&type=script&lang=js&"
export * from "./TableFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports